// CategoriesList.tsx
import React from "react";
import {
  List,
  DatagridConfigurable,
  TextField,
  NumberField,
  BooleanField,
  TopToolbar,
  SelectColumnsButton,
  FilterButton,
  ExportButton,
  CreateButton,
  useDefaultTitle,
  useListContext,
  RaRecord,
  Identifier,
} from "react-admin";
import CustomImageField from "./CustomImageField";

// Optional: Extend RaRecord if you need additional type safety elsewhere.
export interface CategoryRecord extends RaRecord {
  name?: string;
}

const ListActions = () => (
  <TopToolbar>
    <FilterButton />
    <SelectColumnsButton />
    <ExportButton />
    {/* Create button that navigates to the creation page */}
    <CreateButton label="Create Category" />
  </TopToolbar>
);

const UserActionsTitle = () => {
  const title = useDefaultTitle();
  const { defaultTitle } = useListContext();
  return (
    <>
      <title>{`${title} - ${defaultTitle}`}</title>
      <span>{defaultTitle}</span>
    </>
  );
};

const CategoriesList = () => (
  <List
    resource="categories"
    perPage={25}
    actions={<ListActions />}
    filters={[]}
    title={<UserActionsTitle />}
    sort={{ field: "priority", order: "ASC" }}
  >
    <DatagridConfigurable
      rowClick={(id: Identifier, _basePath: string, _record?: RaRecord) => `/categories/${id}/edit`}
      bulkActionButtons={false}
      sx={{
        "& .column-searchIndex": {
          display: { xs: "none", md: "table-cell" },
        },
      }}
    >
      <CustomImageField />
      <TextField source="id" />
      <TextField source="name" />
      <TextField source="layoutType" />
      <NumberField source="priority" />
      <BooleanField source="isHidden" label="Hidden" looseValue />
    </DatagridConfigurable>
  </List>
);

export default CategoriesList;
